module.exports = __webpack_public_path__ + "media/bootstrap-icons/people-92351f65.svg";